var _defs, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_data_svg__c{fill:none;stroke:#2196f3}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.066 31H10.934A1.835 1.835 0 019 29.154V11.845a1.845 1.845 0 011.934-1.847h18.132A1.835 1.835 0 0131 11.845v17.308a1.867 1.867 0 01-1.934 1.846z",
    stroke: "#6f6f6f",
    fill: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(14.728 24.864)",
    fill: "#2196f3",
    fontSize: 10,
    fontFamily: "SegoeUI-Semibold,Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "23"))));
}
export default __webpack_public_path__ + "static/media/icon_data.ce557e91.svg";
export { SvgIconData as ReactComponent };